<template>
  <div>
    <v-list v-if="address" flat class="pt-0">
      <v-list-item-group color="primary">
        <v-list-item>
          <v-list-item-avatar class="py-0 my-0">
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-avatar>

          <v-list-item-content class="py-0 my-0">
            <v-list-item-subtitle class="wrap-text">
              <a v-if="isApple" :href="`maps://?q=${lat},${lon}`">{{ address }}</a>

              <a v-else-if="isAndroid" :href="`geo://?q=${lat},${lon}`">{{ address }}</a>

              <template v-else>{{ address }}</template>
              <!--
              https://gist.github.com/danharper/844382901f7a7b73b90a
              -->
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <template v-if="hasContacts">
      <v-row>
        <v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="py-0">
          <v-list flat>
            <v-list-item-group color="primary">
              <v-list-item v-if="contacts.PHONE">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-cellphone-iphone</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="`tel:${contacts.PHONE}`">{{ contacts.PHONE }}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.PHONE_ADDITIONAL">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-cellphone-iphone</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="`tel:${contacts.PHONE_ADDITIONAL}`">
                      {{ contacts.PHONE_ADDITIONAL }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.WHATSAPP">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-whatsapp</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="`https://wa.me/${cleanPhone(contacts.WHATSAPP)}`" target="_blank">
                      {{ contacts.WHATSAPP }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.TELEGRAM">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-telegram</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="`https://t.me/${contacts.TELEGRAM}`" target="_blank">
                      @{{ contacts.TELEGRAM }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.SITE">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-web</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="contacts.SITE" target="_blank">{{ contacts.SITE }}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.EMAIL">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-at</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="`mailto:${contacts.EMAIL}`">{{ contacts.EMAIL }}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>

        <v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="py-0">
          <v-list flat>
            <v-list-item-group color="primary">
              <!--
              <v-list-item v-if="contacts.INSTAGRAM">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-instagram</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="`https://instagram.com/${contacts.INSTAGRAM}`" target="_blank">
                      {{ contacts.INSTAGRAM }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.FACEBOOK">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-facebook</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="contacts.FACEBOOK" target="_blank">
                      {{ contacts.FACEBOOK }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              -->

              <v-list-item v-if="contacts.VK">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-vk</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="contacts.VK" target="_blank">
                      {{ contacts.VK }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.UNTAPPD">
                <v-list-item-avatar class="py-0 my-0">
                  <v-icon>mdi-untappd</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="contacts.UNTAPPD" target="_blank">
                      {{ contacts.UNTAPPD }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="contacts.RATEBEER">
                <v-list-item-avatar class="py-0 my-0"> </v-list-item-avatar>

                <v-list-item-content class="py-0 my-0">
                  <v-list-item-subtitle class="wrap-text">
                    <a :href="contacts.RATEBEER" target="_blank">
                      {{ contacts.RATEBEER }}
                    </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import MobileDetect from 'mobile-detect';

export default {
  name: 'PlaceInfo',

  props: {
    address: {
      type: String,
      required: true,
    },

    contacts: {
      type: Object,
      required: true,
    },

    options: {
      type: Object,
      required: false,
      default: () => {},
    },

    lat: {
      type: Number,
      required: true,
    },

    lon: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      os: '',
    };
  },

  computed: {
    hasContacts() {
      return Object.values(this.contacts).length > 0;
    },

    hasOptions() {
      return Object.values(this.options).length > 0;
    },

    isApple() {
      return this.os === 'ios';
    },

    isAndroid() {
      return this.os === 'androidos';
    },
  },

  mounted() {
    const md = new MobileDetect(window.navigator.userAgent);
    this.os = (md.os() || '').toLowerCase();
  },

  methods: {
    cleanPhone(phone) {
      return phone.replace(/[^\d]/g, '');
    },
  },
};
</script>

<style>
.v-list-item__title,
.v-list-item__subtitle.wrap-text {
  text-overflow: clip;
  white-space: normal;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
}
</style>
